import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import ReportService from "../Services/ReportService";

const ManageFormula = () => {
    const { uniqueKey } = useParams();
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            const GetBuildAnalysisQuestions = async () => {
                try {
                    const response = await ReportService.GetBuildAnalysisQuestions(token, uniqueKey);
                    if (response && response.STATUS === "SUCCESS") {
                        setQuestions(response.RESPONSE);
                        console.log(response)
                    }
                } catch (error) {
                    console.error("Error fetching questions:", error);
                } finally {
                    setLoading(false);
                }
            };
            GetBuildAnalysisQuestions();
        } else {
            navigate("/Login");
        }
    }, [token, uniqueKey]);

    // Handle moving questions between columns
    const moveToAnalysis = (questionID) => {
        setQuestions((prevQuestions) =>
            prevQuestions.map((q) =>
                q.QuestionID === questionID ? { ...q, IsAnalyse: true } : q
            )
        );
    };

    const moveToGeneral = (questionID) => {
        setQuestions((prevQuestions) =>
            prevQuestions.map((q) =>
                q.QuestionID === questionID ? { ...q, IsAnalyse: false } : q
            )
        );
    };

    // Filter questions dynamically
    const nonAnalysisQuestions = questions.filter((q) => !q.IsAnalyse);
    const analysisQuestions = questions.filter((q) => q.IsAnalyse);

    const HandleSaveBtn = async () => {
        console.log(questions);
        const response = await ReportService.UpdateBuildAnalysisQuestions(token, uniqueKey, questions);
        if (response) {
            alert("saved Successfully");
        }
    }
    return (
        <>
            <Header />
            <div>
                {loading ? (
                    <p>Loading questions...</p>
                ) : (
                    <>
                        <div className="bg-grey2 py-4">
                            <div className="container">
                                <h5>
                                    <Link className="text-dark" to={"/SurveyList"}>Dashboard</Link>
                                    /
                                    <Link className="text-dark" to={`/ManageSurvey/${uniqueKey}`}>Manage Survey</Link>
                                    / Manage Formula
                                </h5>
                            </div>
                        </div>
                        <div className="container my-5 min-hight75vh">

                            <div className="row justify-content-between g-4">
                                {/* Column 1: Non-Analysis Questions */}
                                <div className="max-width465px shadow bg-white p-4">
                                    <h3>General Questions</h3>
                                    <ul className="list-group">
                                        {nonAnalysisQuestions.map((q) => (
                                            <li key={q.QuestionID} className="list-group-item d-flex align-items-center">
                                                <button className="PlusBtn  me-2" onClick={() => moveToAnalysis(q.QuestionID)}>+</button>
                                                {q.Question}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Column 2: Analysis Questions */}
                                <div className="max-width465px shadow bg-white p-4">
                                    <h3>Analytical Questions</h3>
                                    <ul className="list-group">
                                        {analysisQuestions.map((q) => (
                                            <li key={q.QuestionID} className="list-group-item d-flex align-items-center">
                                                <button className="MinusBtn  me-2" onClick={() => moveToGeneral(q.QuestionID)}>-</button>
                                                {q.Question}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <p className="text-center my-3">
                                <button
                                    className="border-0 px-4 py-1 TruveyBG text-white"
                                    onClick={HandleSaveBtn}
                                >
                                    Save
                                </button>
                            </p>
                        </div>
                    </>
                )}

            </div>
        </>
    );
};

export default ManageFormula;
